import contract from "../../../../design/motion-contract.json"
import { isConsumerTabPath } from "./consumer-navigation.ts"

export type PageTransition = "none" | "primary" | "detail" | "flow"
export type MotionNavigation = { readonly previousPath: string | null; readonly nextPath: string; readonly historyReturn?: boolean; readonly reducedMotion?: boolean }

const pathname = (value: string): string => {
  const path = value.split(/[?#]/)[0] || "/"
  return path.length > 1 ? path.replace(/\/$/, "") : path
}

export const routeMotion = (path: string): PageTransition => {
  const normalized = pathname(path)
  const alias = Object.entries(contract.aliases).find(([source]) => source === normalized)?.[1] ?? normalized
  const route = contract.routes.find(({ path: pattern }) => new RegExp(`^${pattern.replace(/:[^/]+/g, "[^/]+")}$`).test(alias))
  switch (route?.transition) {
    case "primary":
      return "primary"
    case "detail":
      return "detail"
    case "flow":
      return "flow"
    default:
      return "none"
  }
}

/** Query/filter updates and browser/app returns keep both content and scroll state. */
export const pageTransition = (navigation: MotionNavigation): PageTransition => {
  if (navigation.previousPath === null || navigation.historyReturn || navigation.reducedMotion) return "none"
  if (pathname(navigation.previousPath) === pathname(navigation.nextPath)) return "none"
  if (isConsumerTabPath(pathname(navigation.previousPath)) && isConsumerTabPath(pathname(navigation.nextPath))) return "none"
  return routeMotion(navigation.nextPath)
}
